import {RemotePostInvoicePdf} from 'data/usecases';
import {PostInvoicePdf} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {MyPaymentsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostInvoicePdf = (): PostInvoicePdf =>
	new RemotePostInvoicePdf(
		makeBFFApiUrl(MyPaymentsFlowEndPoints.invoicePdf),
		makeAuthorizeHttpClientDecorator(),
	);
